export default __webpack_public_path__ + "static/media/Butterfly.8965be1c.png";